// extracted by mini-css-extract-plugin
export var editIcon = "EditIcon-module__editIcon___PGFen";